module.exports = __webpack_public_path__ + "static/media/seoyeon_korean.9a7b5024.mp3";